"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionRequestStatus = void 0;
// RECEIVED deliberately dropped — Phase 2's ingest() is synchronous (no
// pending/in-progress stage), so every stored request already has a
// terminal status the moment it exists.
var DistributionRequestStatus;
(function (DistributionRequestStatus) {
    DistributionRequestStatus["ACCEPTED"] = "ACCEPTED";
    DistributionRequestStatus["DUPLICATE"] = "DUPLICATE";
    DistributionRequestStatus["SUPERSEDED"] = "SUPERSEDED";
    DistributionRequestStatus["INVALID"] = "INVALID";
    // Valid and would have been ACCEPTED, but DISTRIBUTION_PAUSED was on at
    // ingest — recorded for the audit trail, no Distribution round created.
    // Never advances the reports watermark, so the producer's next real
    // publish of the same report is judged as if this one never arrived.
    DistributionRequestStatus["SUPPRESSED"] = "SUPPRESSED";
})(DistributionRequestStatus || (exports.DistributionRequestStatus = DistributionRequestStatus = {}));
